import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';

interface FormParams {
  onSubmit: any;
}
function LabelThresholdForm(params: FormParams) {
  const { onSubmit } = params;
  const { t } = useTranslation();

  return (
    <div>
      <EnhancedForm onSubmit={onSubmit} formId="addLabelThreshold" hideControls>
        <div className="flex my-4">
          <div className="w-full">
            <IdentityField name="code" component={TextFieldAdapter} label={t('global.label')} />
          </div>
        </div>
      </EnhancedForm>
    </div>
  );
}

export default LabelThresholdForm;
